import { Controller } from '@hotwired/stimulus';
import { getComponent } from '@symfony/ux-live-component';
import { createElementFromHTML } from '../utilities/js/helper';
import { WidgetInstance } from 'friendly-challenge';

export default class extends Controller {
    async initialize () {
        this.component = await getComponent(this.element);

        if (!this.hasInitialized) {
            this.hasInitialized = true;
        }

        const $countrySelect = this.element.querySelector('[data-country-code]');

        const $submitBtn = this.element.querySelector('[data-form="submit"]');
        const $form = this.element.querySelector('form');
        const $loadingSpinner = createElementFromHTML(window.OPTIONS.loader);

        const $friendlyCaptcha = this.element.querySelector('.frc-captcha');
        this.friendlyCaptchaWidget = null;

        let captchaTokenIsReady = false;
        let successState = false;
        let captchaValue = null;

        let countryData;

        if ($countrySelect) {
            countryData = $countrySelect.getAttribute('data-country-code').toLowerCase();
        }

        const initCaptcha = () => {
            $submitBtn.setAttribute('disabled', 'disabled');

            this.friendlyCaptchaWidget = new WidgetInstance($friendlyCaptcha, {
                startMode: 'auto',
                // check on rerender
                readyCallback: () => {
                    captchaTokenIsReady = false;
                    checkCaptcha();
                },
                // check on done - the response is the token
                doneCallback: (response) => {
                    captchaTokenIsReady = true;
                    captchaValue = response;
                    checkCaptcha();
                }
            });
        };

        const checkCaptcha = () => {
            if (captchaTokenIsReady) {
                $submitBtn.removeAttribute('disabled');
            } else {
                $submitBtn.setAttribute('disabled', 'disabled');
            }
        };

        const submitForm = (response) => {
            this.element.appendChild($loadingSpinner.cloneNode(true));
            this.component.action('send', { captchaToken: response });
        };

        if ($friendlyCaptcha) {
            initCaptcha();
        }

        if (this.hasInitialized) {
            // to prevent form from submit
            $form.addEventListener('submit', (e) => {
                e.preventDefault();
            });

            $submitBtn.addEventListener('click', () => {
                submitForm(captchaValue);
            });
        }

        this.component.on('render:finished', () => {
            const $loader = this.element.querySelector('[data-loader]');

            if ($loader) {
                $loader.remove();
            }

            successState = JSON.parse(this.element.dataset.contactSuccess);

            if ($friendlyCaptcha && !successState) {
                this.friendlyCaptchaWidget.reset();
                this.friendlyCaptchaWidget.start();
            }

            checkCaptcha();

            if (this.element && countryData != null) {
                const currentSelectedCountry = $countrySelect.getAttribute('data-country-code').toLowerCase();

                if (currentSelectedCountry !== countryData) {
                    countryData = currentSelectedCountry;
                }
            }
        });
    }
}
